export const actionMap = {}

export const defaultState = {
    data: undefined,
    isLoading: true,
    selectedIds: undefined,
    loadingIds: undefined,
    blobUrl: undefined
}

export default (reduxState = defaultState, action) => {
    if (action !== undefined && actionMap[action.type]) {
        return actionMap[action.type](reduxState, action)
    }
    return reduxState
}



// WEBPACK FOOTER //
// ./src/screens/sigcharts/reducers/index.js